import { EntityEventType } from '@racemap/sdk/schema/entityEvents';
import { RacemapColors } from '@racemap/utilities/consts/common';

export const entityEventColorMap: Record<string, string> = {
  [EntityEventType.AWAY_FROM_TRACK]: RacemapColors.LightOrange,
  [EntityEventType.LOW_BATTERY]: RacemapColors.LightOrange,
  [EntityEventType.CRASH]: RacemapColors.AltRed,
  [EntityEventType.NO_MOVEMENT]: RacemapColors.LightOrange,
  [EntityEventType.SOS]: RacemapColors.AltRed,
  [EntityEventType.POWER_OFF]: RacemapColors.LightOrange,
};
